import ability from './ability'

export const canNavigate = to => to.matched.some(route => {
  const { resource, action } = route.meta

  if (!resource) return true

  if (Array.isArray(resource)) {
    return resource.some(r => ability.can(action || 'read', r))
  }

  return ability.can(action || 'read', resource)
})

export const _ = undefined
